import React from 'react';
import Page from './Page';
import DataPages from './API_Pages';

export class __Pages extends React.Component {

  componentDidMount() {
    var linkWithRef = window.location.href.indexOf("?refbook=");

    if (linkWithRef !== -1) {
      var refBook = window.location.href.substr(linkWithRef + 9);
      var offset = document.getElementById(refBook).offsetTop-100;
      setTimeout(() => {
        window.scrollTo(0, offset);
      }, 1);
    }
  }

  render () {
    return (
      <div className="content fading">
        <h1>Pages</h1>
        <p className="subtitle">Every book consist of 4-12 pages that can follow single theme (food, animals, count, sea, transport, etc) or combine several different. Every page has something new to learn in fun and playful manner. So go ahead take a tour, choose your favourite "ingridients" or come up with your own brilliant ideas.</p>
        <section>
          <ul className="pages">
            {
              DataPages.all().map(p => (
                  <Page key={p.number} type={p.type} id={p.name} class={p.label} title={p.name} descr={p.descr} />
                )
              )
            }
          </ul>
        </section>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/__Pages.js